import React, { useEffect, useRef } from "react";

export default function LocationMap({ pickupLocation, deliveryLocation, }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const pickupMarkerRef = useRef(null);
  const deliveryMarkerRef = useRef(null);
  const directionsRendererRef = useRef(null);
  useEffect(() => {
    if (!window.google || !window.google.maps) {
      return;
    }
    if (!mapRef.current) {
      return;
    }
    const defaultCenter = { lat: 11.3410, lng: 77.7172, };
    if (!mapInstanceRef.current) {
      mapInstanceRef.current =
        new window.google.maps.Map(mapRef.current, {
          center: defaultCenter,
          zoom: 6,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: true,
          zoomControl: true,
          gestureHandling: "cooperative",
        });
    }
    const map = mapInstanceRef.current;
    if (pickupMarkerRef.current) {
      pickupMarkerRef.current.setMap(null);
      pickupMarkerRef.current = null;
    }
    if (deliveryMarkerRef.current) {
      deliveryMarkerRef.current.setMap(null);
      deliveryMarkerRef.current = null;
    }
    if (directionsRendererRef.current) {
      directionsRendererRef.current.setMap(null);
      directionsRendererRef.current = null;
    }
    const bounds = new window.google.maps.LatLngBounds();
    let hasLocation = false;
    if (
      pickupLocation &&
      pickupLocation.lat &&
      pickupLocation.lng
    ) {
      const pickupPosition = {
        lat: Number(pickupLocation.lat),
        lng: Number(pickupLocation.lng),
      };
      pickupMarkerRef.current =
        new window.google.maps.Marker({
          position: pickupPosition, map, title: pickupLocation.address || "Pickup Location",
          label: { text: "P", color: "#ffffff", fontWeight: "700", },
        });
      bounds.extend(pickupPosition);
      hasLocation = true;
    }
    if (deliveryLocation && deliveryLocation.lat && deliveryLocation.lng) {
      const deliveryPosition = {
        lat: Number(deliveryLocation.lat),
        lng: Number(deliveryLocation.lng),
      };
      deliveryMarkerRef.current = new window.google.maps.Marker({
        position: deliveryPosition, map,
        title: deliveryLocation.address || "Delivery Location",
        label: { text: "D", color: "#ffffff", fontWeight: "700", },
      });
      bounds.extend(deliveryPosition);
      hasLocation = true;
    }
    if (pickupLocation && deliveryLocation && pickupLocation.lat && pickupLocation.lng && deliveryLocation.lat && deliveryLocation.lng) {
      const directionsService = new window.google.maps.DirectionsService();
      const directionsRenderer =
        new window.google.maps.DirectionsRenderer({
          map, suppressMarkers: true,
          polylineOptions: {
            strokeColor: "#f5a900",
            strokeOpacity: 0.9,
            strokeWeight: 5,
          },
        });
      directionsRendererRef.current = directionsRenderer;
      directionsService.route(
        {
          origin: {
            lat: Number(pickupLocation.lat),
            lng: Number(pickupLocation.lng),
          },
          destination: {
            lat: Number(deliveryLocation.lat),
            lng: Number(deliveryLocation.lng),
          },
          travelMode:
            window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === "OK") {
            directionsRenderer.setDirections(
              result
            );
          }
        }
      );
    }
    if (hasLocation) {
      map.fitBounds(bounds);
      window.google.maps.event.addListenerOnce(
        map,
        "bounds_changed",
        () => {
          if (map.getZoom() > 15) {
            map.setZoom(15);
          }
        }
      );
    } else {
      map.setCenter(defaultCenter);
      map.setZoom(6);
    }
  }, [pickupLocation, deliveryLocation]);
  return (
    <div className="location-map-card">
      <div className="location-map-header">
        <div>
          <h4>Move Route</h4>
          <p>Pickup and delivery locations</p>
        </div>
        <div className="location-map-legend">
          <span>
            <i className="pickup-dot">P</i>Pickup</span>
          <span>
            <i className="delivery-dot">D</i>Delivery</span>
        </div>
      </div>
      <div ref={mapRef} className="location-map" />
    </div>
  );
}